import EficienciaReproductivaModal from "./EficienciaReproductivaModal";
export default EficienciaReproductivaModal;